import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { ArrowBackIos, LocalDrinkOutlined } from "@material-ui/icons";
import { useHistory, useParams } from "react-router-dom";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { Container } from "./styles";
import { useEffect } from "react";
import { API_HADES } from "shared/services";
import {
  ByAttribute,
  ByBroker,
  ByRouting,
} from "modules/distribution/components";
import { useMainState } from "modules/app/contexts";
import ByRescueUser from "modules/distribution/components/ByRescueUser/ByRescueUser";
import { toast } from "react-toastify";

function RuleForm() {
  const [rule, setRule] = useState({});
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState({
    distribution_types: {},
    distribution_roles: {},
    distribution_routing_types: {},
  });
  const { users, company, user } = useMainState();
  const [type, setType] = useState();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (user.role == "seller") {
      history.push("/");
    }
  }, [user]);

  useEffect(() => {
    async function loadData() {
      const result = await API_HADES.get("info_for_create");
      setOptions(result.data);

      if (id) {
        const result = await API_HADES.get(`/distribution/rules/${id}`);
        setType(result.data.distribution_type);
        setRule(result.data);
      }

      setLoading(false);
    }

    loadData();
  }, []);

  function renderFormToCreateRules(type) {
    switch (type) {
      case "ByRescueUser":
        return (
          <ByRescueUser
            rule={rule}
            company_id={company.id}
            users={users}
            teams={company.company_teams}
            options={options}
            distribution_type={type}
            handleSubmit={handleSubmit}
          />
        );
      case "ByBroker":
        return (
          <ByBroker
            rule={rule}
            company_id={company.id}
            users={users}
            teams={company.company_teams}
            options={options}
            distribution_type={type}
            handleSubmit={handleSubmit}
          />
        );
      case "ByAttribute":
        return (
          <ByAttribute
            rule={rule}
            company_id={company.id}
            users={users}
            teams={company.company_teams}
            options={options}
            distribution_type={type}
            handleSubmit={handleSubmit}
          />
        );
      case "ByRouting":
        return (
          <ByRouting
            rule={rule}
            company_id={company.id}
            users={users}
            teams={company.company_teams}
            options={options}
            distribution_type={type}
            handleSubmit={handleSubmit}
          />
        );
    }
  }

  async function handleSubmit(params) {
    if (id) {
      updateRule(params);
    } else {
      createRule(params);
    }
  }

  async function createRule(params) {
    try {
      await API_HADES.post("/distribution/rules", params);
      toast.success("Regra de distribuição cadastrada com sucesso");

      history.push("/app/rules");
    } catch (_e) {
      toast.error("Falha ao cadastrar");
    }
  }

  async function updateRule(params) {
    try {
      params.rule.id = id;
      await API_HADES.put(`/distribution/rules/${id}`, params);
      toast.success("Regra de distribuição atualizada com sucesso");

      history.push("/app/rules");
    } catch (_e) {
      toast.error("Falha ao atualizar");
    }
  }

  if (loading) return <></>;

  return (
    <Container>
      <Typography
        style={{
          fontWeight: "bold",
          fontSize: 22,
          display: "flex",
          justifyContent: "row",
          alignItems: "center",
        }}
      >
        <ArrowBackIos
          onClick={() => history.goBack()}
          className="icon-button"
        />
        Criar nova regra
      </Typography>

      <Grid
        container
        alignItems="baseline"
        spacing={1}
        style={{ marginTop: 28 }}
      >
        <Grid item style={{ textAlign: "right", width: "20%" }}>
          Tipos de regras
        </Grid>

        <Grid item style={{ width: "50%" }}>
          <RadioGroup
            aria-label="position"
            name="position"
            defaultValue="top"
            style={{ paddingLeft: 14 }}
          >
            {Object.keys(options.distribution_types).map((value) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio color="primary" />}
                onChange={(e) => setType(e.target.value)}
                label={options.distribution_types[value]}
                checked={value == type}
              />
            ))}
          </RadioGroup>
        </Grid>
      </Grid>

      {renderFormToCreateRules(type)}
    </Container>
  );
}

export default RuleForm;
